exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".unit4a-1 .intro ul{margin:-2px 0}.unit4a-1 .intro ol{font-weight:700;border-bottom:3px solid #fcf390;padding-bottom:45px}.unit4a-1 .simplest__structure-block{color:#050e61}.unit4a-1 .simplest__structure-box textarea{border-color:#050e61}.unit4a-1 .submit{position:static}.unit4a-1 .desc-table{display:flex;flex-direction:row;justify-content:space-between}.unit4a-1 .desc-table__title{margin-bottom:24px!important;font-size:24px;font-weight:700}.unit4a-1 .desc-table .double-title{margin-bottom:25px!important}.unit4a-1 .desc-table p{margin-bottom:13px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./client/app/modules/courses/4/4a/practiceInSeeing/practiceInSeeing.scss
// module id = 732
// module chunks = 0